// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"FloresHeaderLogo_logoContainer__8w2Lr","logo":"FloresHeaderLogo_logo__1QHFV"};